import { Component } from 'react';
import NoteModule from './NoteModule';
import NoteForm from '../forms/NoteForm';
import Icon from '../atoms/Icon';
import { makeBEM } from '../global/utils';
import { LABELS } from '../global/constants';
import { FormReveal } from './Animations';
import { GeneralObserver } from './Observer';

class NotesModule extends Component {

	constructor(props) {
		super(props);

		this.state = {
			boardID: this.props.boardID,
			controller: this.props.controller ? this.props.controller : [],
			notes: [],
			showForm: false,
		};

		this.observer = false;
		this.moduleName = 'notes';
		this.bindFunctions();
	}

	bindFunctions() {
        this.showFormBtnClick = this.showFormBtnClick.bind(this);
        this.discardForm = this.discardForm.bind(this);
		this.deleteNote = this.deleteNote.bind(this);
		this.reactFn = this.reactFn.bind(this);
	}

	componentDidMount() {
		this.initialSetup();
	}

	// Setup observer and subscribe to events from controller
    // Fetch data from controller 
	initialSetup() {
		const ctrl = this.state.controller;
		this.observer = new GeneralObserver(this.reactFn);

		ctrl.addObserver(this.observer);
		ctrl.fetchNotes();

		this.setState({
			controller: ctrl,
		});
	}

	// Updates notes data from controller when controller's Observer notifies subject
	reactFn() {
		const ctrl = this.state.controller;
		const newData = ctrl.getNotes();

		this.setState({
			controller: ctrl,
			notes: newData,
		})
	}

	// Manages NoteForm visibility by negating showForm state 
	toggleFormVisibility() {
        const formShown = this.state.showForm;

        this.setState({
            showForm: !formShown
        });
    }

	// Helper for form button
    showFormBtnClick() {
        this.toggleFormVisibility();
    }

	// Helper to discard form
    discardForm() {
        this.toggleFormVisibility();
    }

	// Takes in id and calls controller delete note fn
	deleteNote(id=-1) {
		if ( id !== -1 ) {
			const ctrl = this.state.controller;
			ctrl.delete(id);
		}
	}

	// Renders dummy content while reloading
	renderDummyContent() {
		return (
			<div>
				<div className="note dummy">
					<p className="note__body shimmer"></p>
					<p className="note__body shimmer"></p>
					<p className="note__body shimmer"></p>
				</div>
				<div className="note dummy">
					<p className="note__body shimmer"></p>
					<p className="note__body shimmer"></p>
					<p className="note__body shimmer"></p>
					<p className="note__body shimmer"></p>
					
				</div>
				<div className="note dummy">
					<p className="note__body shimmer"></p>
					<p className="note__body shimmer"></p>
					<p className="note__body shimmer"></p>
				</div>
			</div>
		);
	}
	
	// Renders list of notes
	renderNotes() {
		const ctrl = this.state.controller;
		if ( !ctrl ) {
			return false;
		}

		const notes = this.state.notes;
		const hasNotes = notes.length > 0;

		const reloading = this.props.reloading;
		const renderContent = !reloading;
		const showFormBtn = !reloading;

		const showForm = this.state.showForm;
		const showFormBtnClass = `btn--icon-and-text ${makeBEM(this.moduleName, 'show-form-btn')}`;		

		return (
	    		<div className={ this.moduleName }>
					{ reloading &&
						this.renderDummyContent()
					}

	    			{
						hasNotes && renderContent &&
						Object.keys(notes).map(key => (
	    				
							<NoteModule 
								key={notes[key].id}
								data={ notes[key] }
								animate={ notes[key].animate }
								deleteAction={this.deleteNote}
							/>
	    				
			    		))
					}

					{
						showFormBtn &&
						<div className="board__form-btn">
							<button
								className={ showFormBtnClass }
								onClick={ this.showFormBtnClick  }
							>
								<Icon name="plus" size="2"/>{ LABELS.newNote } 
							</button>
						</div>
                    }
					
					{
						showForm &&
						<FormReveal key={0}> 
							<NoteForm
								boardID={this.state.boardID}
								discardForm={this.discardForm}
								controller={ctrl}
							/>
						</FormReveal>
					}

		    	</div>
	    );
	}

	render() {
	   return (
	   		this.renderNotes()
	   	);
  	}
}

export default NotesModule;